<div class="padded-container">

    <dx-accordion [collapsible]="true" [multiple]="true" (onContentReady)="onContentReady($event)">
        <dxi-item title="{{ 'ProblemsNotHandedOverToService' | translate }}" [expanded]="true">
            <div *ngIf="registeredCarFaultsResponse?.carFaults?.length">
                <div *ngFor="let fault of registeredCarFaultsResponse?.carFaults">
                    <dx-text-box [(value)]="fault.faultNotes" class="full-width-button" [readOnly]="true"></dx-text-box>
                </div>
            </div>
            <div *ngIf="!registeredCarFaultsResponse?.carFaults?.length">
                <span>{{ 'NoRegisteredCarFaults' | translate }}</span>
            </div>
        </dxi-item>
        <dxi-item title="{{ 'HandedOverProblemsToService' | translate }}" [expanded]="true">
            <div *ngIf="inServiceCarFaultsResponse?.carFaults?.length">
                <div *ngFor="let fault of inServiceCarFaultsResponse?.carFaults">
                    <dx-text-box [(value)]="fault.faultNotes" class="full-width-button" [readOnly]="true"></dx-text-box>
                </div>
            </div>
            <div *ngIf="!inServiceCarFaultsResponse?.carFaults?.length">
                <span>{{ 'NoInServiceCarFaults' | translate }}</span>
            </div>
        </dxi-item>
    </dx-accordion>

    <div *ngFor="let comment of comments">
        <dx-text-area [(ngModel)]="comment.text" class="full-width-button" placeholder="{{ 'TypeYourProblemHere' | translate }}" [placeholder]="'TypeTheProblemHere' | translate"></dx-text-area>
    </div>

    <dx-button text="{{ 'AdditionalComment' | translate }}" (onClick)="addComment()" class="full-width-button" type="default"></dx-button>

    <dx-button text="{{ 'Continue' | translate }}" (onClick)="continueNextStep()" class="full-width-button" type="default"></dx-button>

    <dx-button text="{{ 'Back' | translate }}" (onClick)="navigateToService()" class="full-width-button" type="default"></dx-button>
</div>